import React, { FC, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { apiEmployeeService } from "../../../../../shared/services/employee-service";
import { notificationService } from "../../../../../shared/services/notification-service";
import { LeaveRequestService } from "../../../../../shared/services/leave-request";
import { useParams } from "react-router-dom";

interface LeaveQuotaRowProps {
  type_name: string | null;
  total_leave: string | null;
  total_use: string | null;
  total_remain: string | null;

  onEdit: boolean;
}

type LeaveData = {
  type: string;
  used_days: number;
  total_days_allowed: number;
};

export type LeaveHistoryTypeTotal = {
  totalLeaveAmount: number;
  leaveByTypeTotal: LeaveData[];
  usedLeavePercentage: number;
};

const LeaveQuotaForm: FC = () => {
  const { id } = useParams();
  const [employeeData, setEmployeeData] = useState([]) as any;
  const [leaveHistoryTypeTotal, setLeaveHistoryTypeTotal] = useState(
    {} as LeaveHistoryTypeTotal
  );

  const fetchData = async () => {
    try {
      const userId = {
        user_id: employeeData?.user?.id,
      };
      const leaveHistoryTypeTotal =
        await LeaveRequestService.getLeaveHistoryTypeTotal(userId);
        
      if (leaveHistoryTypeTotal.length !== 0) {
        setLeaveHistoryTypeTotal(leaveHistoryTypeTotal);
      }
    } catch (error) {
      const err = error as any;
      if (err.response?.status === 400) {
        notificationService.dangerNotification(
          "ไม่พบข้อมูล",
          err.response.data.message
        );
      } else {
        notificationService.dangerNotification("ระบบขัดข้อง", err.message);
      }
    } finally {
    }
  };

  const getEmployeeMe = async () => {
    let response = null;
    if (id) {
      response = await apiEmployeeService.getEmployeeDetail(Number(id));
    } else {
      response = await apiEmployeeService.getEmployeeMe();
    }
    if (response.length !== 0) {
      setEmployeeData(response);
    }
  };
  useEffect(() => {
    getEmployeeMe();
    if (employeeData?.user?.id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (employeeData?.user?.id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeData?.user?.id]);

  const onEdit = true;
  // Create a mapping between leave type names and their corresponding data
  const getUpdatedLeaveQuotaData = () => {
    return (
      leaveHistoryTypeTotal?.leaveByTypeTotal?.map((quota) => {
        return {
          type_name: quota.type,
          total_leave: quota.total_days_allowed.toString(),
          total_use: quota.used_days.toString(),
          total_remain: (quota.total_days_allowed - quota.used_days).toString(),
        };
      }) || []
    );
  };

  // Replace the static LeaveQuotaData mapping with the dynamic one
  return (
    <div className="overflow-auto">
      <Table bordered>
        <thead>
          <tr className="border-0">
            <th>ประเภท</th>
            <th>วันลาทั้งหมด</th>
            <th>ใช้แล้ว</th>
            <th>วันลาคงเหลือ</th>
          </tr>
        </thead>
        <tbody>
          {getUpdatedLeaveQuotaData().map((data, index) => {
            return (
              <LeaveQuotaRow
                key={index}
                type_name={data.type_name}
                total_leave={data.total_leave}
                total_use={data.total_use}
                total_remain={data.total_remain}
                onEdit={onEdit}
              />
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

const LeaveQuotaRow: FC<LeaveQuotaRowProps> = ({
  type_name,
  total_leave,
  total_use,
  total_remain,
  onEdit = false,
}) => {
  return (
    <tr className="bg-white">
      <td>{type_name}</td>
      <td>{total_leave || "-"}</td>
      <td>{total_use || "-"}</td>
      <td>{total_remain || "-"}</td>
    </tr>
  );
};

export default LeaveQuotaForm;
